import { PlaceholderColor } from '../../types'

export const lookupPlaceholderHex = (color: PlaceholderColor): string =>
  ({
    [PlaceholderColor.green]: '#DCFFEC',
    [PlaceholderColor.pink]: '#F9E2E2',
    [PlaceholderColor.purple]: '#EDE7FB',
    [PlaceholderColor.white]: '#FFFFFF',
    [PlaceholderColor.yellow]: '#FFFFE0',
  })[color]
